import { useState } from 'react'

import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

import { ConfirmationDialog, Permitted } from 'components'
import { FormDeleteDialog } from '..'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import constants from 'constants/index'

const ActionButtons = ({
  organization,
  refresh = () => {},
  setIsLoading = () => {},
}) => {
  const [openActivateDialog, setOpenActivateDialog] = useState(false)
  const [openInactivateDialog, setOpenInactivateDialog] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)

  const snackbar = useSnackbar()

  const organizationIsInactive =
    organization?.status === constants.organizations.STATUSES.INACTIVE

  const handleActiveOrInactive = async () => {
    try {
      setIsLoading(true)
      await service.backoffice.organizations.changeStatus({
        organizationId: organization?.id,
      })

      snackbar.open({
        message: `Grupo Advisor ${
          organizationIsInactive ? 'ativado' : 'inativado'
        } com sucesso!`,
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: `Falha ao ${
          organizationIsInactive ? 'ativar' : 'inativar'
        } Grupo Advisor.`,
        variant: 'error',
      })
    } finally {
      setOpenActivateDialog(false)
      setOpenInactivateDialog(false)
      setIsLoading(false)
      refresh()
    }
  }

  return (
    <>
      <Permitted tag={constants.permissions.ORGANIZATION.MANAGE}>
        {organizationIsInactive ? (
          <Button
            fullWidth
            size="small"
            onClick={() => {
              setOpenActivateDialog(true)
            }}
          >
            Ativar
          </Button>
        ) : (
          <Button
            fullWidth
            size="small"
            onClick={() => {
              setOpenInactivateDialog(true)
            }}
          >
            Inativar
          </Button>
        )}
      </Permitted>
      <Permitted tag={constants.permissions.ORGANIZATION.MANAGE}>
        <Button
          fullWidth
          size="small"
          onClick={() => {
            setOpenDeleteDialog(true)
          }}
        >
          Excluir
        </Button>
      </Permitted>

      <ConfirmationDialog
        open={openActivateDialog}
        setOpen={setOpenActivateDialog}
        message="Tem certeza que deseja ativar este Grupo Advisor?"
        cancelButtonText="Cancelar"
        buttonText="Ativar"
        actionAcceptButton={handleActiveOrInactive}
      />
      <ConfirmationDialog
        open={openInactivateDialog}
        setOpen={setOpenInactivateDialog}
        message="Tem certeza que deseja inativar este Grupo Advisor?"
        cancelButtonText="Cancelar"
        buttonText="Inativar"
        actionAcceptButton={handleActiveOrInactive}
      />
      <FormDeleteDialog
        open={openDeleteDialog}
        setOpen={setOpenDeleteDialog}
        organizationId={organization?.id}
        refresh={refresh}
        setIsLoading={setIsLoading}
      />
    </>
  )
}

ActionButtons.propTypes = {
  organization: PropTypes.object,
  refresh: PropTypes.func,
  setIsLoading: PropTypes.func,
}

export default ActionButtons
